import { DatePicker } from '@atlaskit/datetime-picker';
import NoValue from 'Components/Atoms/NoValue/NoValue';
import Tag from 'Components/Atoms/Tag/Tag';
import TagGroup from 'Components/Molecules/TagGroup/TagGroup';
import { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useOuterClick } from 'Services/helpers';
import styles from './DateField.module.sass';
import './DateField.sass';

export const formatDate = (number: any) => number < 10 ? '0' + number : number;

interface DateField {
    isEdit: any,
    value: string,
    onChange: (value: string) => any,
}

const DateField = ({isEdit, value: rawValue, onChange}: DateField) => {
    const isEmpty = !rawValue;
    const displayFormat = new Date(rawValue);

    if (!isEdit) {
        if (isEmpty) {

            return <NoValue />;
        }

        return <>{formatDate(displayFormat.getDate()) + '-' + formatDate(displayFormat.getMonth()+1) + '-' + displayFormat.getFullYear()}</>;
    }

    return <DatePicker
        value={rawValue}
        dateFormat="DD-MM-YYYY"
        locale={'nl-NL'}
        onChange={(value: any) => {onChange(value)}}
        placeholder={'Selecteer een datum...'}
    />;
}

export default connect(() => ({}), {})(DateField);